/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./style.less";
import Request from "../../utils/request";
import CountDown from './countdown';
import shihuo from "shihuo-lib/dist/shihuo-lib";
import utils from "../../utils/utils";
class PipelineCashBackAct extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogin: false,
      coupon_list: [],
      is_rec: false,
      expire_time: '',
      popupShow: false,
      coupons_show: false
    };
    this.interval = null;
    this.loginInterVal = null;
    this.isNewVersionUI = props.config.couponsConfig.couponNumber ? true : false;
    this.pageId = utils.getPageId();
    this.app_version = utils.getVersion();
  }

  componentDidMount() {
    this.queryLoginStatus();
  }

  // 轮询判断是否登陆成功
  judgeIsLogin = () => {
    this.loginInterval && clearInterval(this.loginInterval);
    this.loginInterval = setInterval(() => {
      const { isLogin } = this.state;
      if (!isLogin) {
        const CookieUA = utils.getCookie('ua');
        const CookieU = utils.getCookie('u');
        if (CookieUA && CookieU) {
          Promise.all([CookieUA, CookieU]).then(result => {
            this.setState({
              isLogin: result && result[0] && result[1]
            });
          })
        }
      } else {
        this.loginInterval && clearInterval(this.loginInterval);
        this.loginInterval = null;
      }
    }, 500);
  }

  // 登录
  handleLogin = () => {
    if (utils.isShihuo()) {
      // 未登陆，请先进行微信登陆
      if (this.loginInterVal) {
        return;
      }
      if (!utils.isAndroid() && (utils.SHDiffVersion(this.app_version, '6.86.0'))) {
        this.judgeIsLogin();
      } else {
        window.Jockey.send("subscribe", {}, (publishData) => {
          if (publishData.type === "loginSuccess") {
            this.loginInterVal = setInterval(() => {
              this.queryLoginStatus();
            }, 500);
          }
          setTimeout(() => {
            this.loginInterVal && clearInterval(this.loginInterVal);
            this.loginInterVal = null;
          }, 15000);
        });
      }
      window.Jockey.send("action", {
        url: "shihuo://www.shihuo.cn?route=login",
      });
    }
  }

  // 查询登录状态
  queryLoginStatus = () => {
    try {
      Request({
        url: `https://sh-gateway.shihuo.cn/v4/services/sh-user/user/baseInfo?from=${this.pageId}&need_wechat_info=false&complicate=true`,
        method: 'get',
        withCredentials: true,
      }).then(res => {
        const { status, data } = res.data;
        if (status === 0) {
          if (data.user_info && data.user_info.uid) {
            this.loginInterVal && clearInterval(this.loginInterVal);
            this.loginInterVal = null;
            this.setState({
              isLogin: true
            }, () => {
              this.queryCouponsStatus();
            })
          }
        } else {
          this.setState({
            isLogin: false
          }, () => {
            this.queryCouponsStatus();
          })
        }
      })
    } catch (error) {
      this.queryCouponsStatus();
    }
  }

  // 查询券状态
  queryCouponsStatus = () => {
    const { couponsConfig } = this.props.config;
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/lego_coupon/couponInfo?access_token=2322TizdV3pjw8CBsy&activity_code=' + couponsConfig.activityCode,
      method: 'get',
      withCredentials: true,
    }).then(res => {
      const { status, data } = res.data;
      if (status === 0) {
        const { list } = data;
        this.setState({
          coupons_show: true,
          coupon_list: list,
          is_rec: (list && list.length > 0) ? true : false,
          expire_time: list && list[0] && list[0].end_time.replace(/-/g, '/'),
        });
      } else {
        this.setState({
          coupons_show: true,
        });
      }
    })
  }

  // 领取券
  getCashbackCoupons = () => {
    const { couponsConfig } = this.props.config;
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/lego_coupon/recCoupon?access_token=2322TizdV3pjw8CBsy',
      method: 'post',
      withCredentials: true,
      data: {
        activity_code: couponsConfig.activityCode,
      },
    }).then(res => {
      const { status, msg } = res.data;
      if (status !== 0) {
        window.Jockey.send('toast', {
          text: msg
        });
      } else {
        window.Jockey.send('toast', {
          text: '领取成功'
        });
        this.queryCouponsStatus();
      }
    })
  }

  handleItemClick = () => {
    shihuo.uploadTrack({
      from: typeof window !== "undefined" ? window.location.href : "",
      block: this.props.customAttributes ? this.props.customAttributes['data-component-block']: "",
      pageId: this.pageId,
      pti: {
        id: '',
        name: '',
        pageId: this.pageId,
        biz:'',
        root: {
          id: '',
          pageId: '',
          name: '',
          biz:  '',
        },
        parent: {
          id: '',
          pageId: '',
          name: '',
          biz: '',
        },
      },
    });
    utils.uploadTrack(this.props);

    if (!this.state.isLogin) {
      this.handleLogin();
      return;  
    }

    if (!this.state.is_rec) {
      this.getCashbackCoupons(); 
    }
  };

  handleRuleClick = () => {
    if (this.isNewVersionUI) {
      const ruleUrl = 'shihuo://www.shihuo.cn?route=RNProgram&page=MyActivityShow&miniId=Shihuo_Category';
      utils.jumpToUrl(this.props.routeParams, ruleUrl, ruleUrl, {}, -1, this.props);
    } else {
      this.setState({
        popupShow: true
      });  
    }
  }

  closePopup = () => {
    this.setState({
      popupShow: false
    })
  }

  // 单张券
  renderSingleCoupon() {
    const { couponsConfig = {} } = this.props.config;
    const { singleCouponMaterial = {}, singleCoupon = [{}] } = couponsConfig;
    const { couponPackageBackgroundImage = '', unReceivedBtnImage = '', hasReceivedBtnImage = '', textColor = '' } = singleCouponMaterial;
    const { is_rec } = this.state;
    return (
      <div
        className="single-coupon"
        style={{
          backgroundImage: `url(${couponPackageBackgroundImage || 'https://static.shihuocdn.cn/admin/files/20231129/e96dcc238cf4e2bd80ca1ba1314dec42.png'})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain'
        }}
      >
        <div className="price" style={{color: textColor}}>
          {
            singleCoupon[0] && (
              <Fragment>
                <span>¥</span>{singleCoupon[0].price}
              </Fragment>
            )
          }
        </div>
        <div className="coupon-info">
          <p className="coupon-name" style={{color: textColor}}>{singleCoupon[0] && singleCoupon[0].title.slice(0, 10)}</p>
          <p className="coupon-desc" style={{color: textColor}}>{singleCoupon[0] && singleCoupon[0].subTitle.slice(0, 12)}</p>
          <img src={!is_rec ? (unReceivedBtnImage || 'https://static.shihuocdn.cn/admin/files/20231129/3dd88e1a8d5703f615bcd6fc66e9740e.png') : (hasReceivedBtnImage || 'https://static.shihuocdn.cn/admin/files/20231129/db23ba752aa4442308107dcd2ef76953.png')} alt="" className="btn" onClick={() => this.handleItemClick()} />
        </div>
      </div>
    )
  }

  // 多张券
  renderMultipleCoupon() {
    const { couponsConfig = {} } = this.props.config;
    const { multipleCouponMaterial = {}, multipleCoupon = [] } = couponsConfig;
    const { couponPackageBackgroundImage = '', unReceivedBtnImage = '', hasReceivedBtnImage = '', couponBackgroundImage = '', textColor = '' } = multipleCouponMaterial;
    const { is_rec } = this.state;
    return (
      <div
        className="multiple-coupon"
        style={{
          backgroundImage: `url(${couponPackageBackgroundImage || 'https://static.shihuocdn.cn/admin/files/20231129/321e1f014fe60f8b4960f367aea3c76d.png'})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain'
        }}
      >
        <div className="scroll">
          <ul>
            {
              multipleCoupon.map((item, index) => {
                return (
                  <li
                    className="coupon-item"
                    key={index}
                    style={{
                      backgroundImage: `url(${couponBackgroundImage || 'https://static.shihuocdn.cn/admin/files/20231129/82e618e51107a8f0f3dcd0ff93792c62.png'})`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'contain'
                    }}
                  >
                    <p className="price" style={{color: textColor}}>
                      <span>¥</span>{item.price}
                    </p>
                    <div className="coupon-info">
                      <p className="coupon-name" style={{color: textColor}}>{item.title.slice(0, 5)}</p>
                      <p className="coupon-desc" style={{color: textColor}}>{item.subTitle.slice(0, 6)}</p>
                    </div>
                  </li>
                )
              })
            }
          </ul>
        </div>
        <img src={!is_rec ? (unReceivedBtnImage || 'https://static.shihuocdn.cn/admin/files/20231129/8305322ae5b9a24d8776aff27a472436.png') : (hasReceivedBtnImage || 'https://static.shihuocdn.cn/admin/files/20231129/f46f299697fe64ad67f6ff2148dc0b8d.png')} alt="" className="btn" onClick={() => this.handleItemClick()} />
      </div>
    )
  }

  render() {
    const { baseConfig } = this.props.config;
    const { coupons_show } = this.state;
    if (!coupons_show) {
      return null;
    } 
    return (
      <div
        className={`pipeline-cashBackAct ${this.isNewVersionUI ? 'new-version-ui' : 'old-version-ui'}`}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px',
        }}
      >
        {
          this.isNewVersionUI
            ? this.renderNewVersionUI()
            : this.renderOldVersionUI()
        }
      </div>
    );
  }

  renderNewVersionUI() {
    const { baseConfig, couponsConfig } = this.props.config;
    const { is_rec, expire_time } = this.state;
    return (
      <Fragment>
        <div className="modlue-title">
          <div className="title">
            <p className="main-title" style={{color: baseConfig.titleColor}}>{baseConfig.title && baseConfig.title.slice(0, 8)}</p>
            {
              (is_rec && !couponsConfig.noCountDown) ? (
                <div className="count-down" style={{color: baseConfig.titleColor}}>
                  <CountDown end_time={expire_time} isNewVersionUI={this.isNewVersionUI} />
                </div>
              ) : <p className="sub-title" style={{color: baseConfig.titleColor}}>{baseConfig.subTitle && baseConfig.subTitle.slice(0, 12)}</p>
            }
          </div>
          <div className="rule" style={{color: baseConfig.titleColor}} onClick={() => this.handleRuleClick()}>
            规则
            <svg t="1699620535441" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="2255" width="9" height="9">
              <path d="M542.72 98.304a42.666667 42.666667 0 0 0-66.218667 53.418667l4.864 5.973333 354.304 365.738667-353.28 341.930666a42.666667 42.666667 0 0 0-5.888 54.357334l4.864 5.973333a42.666667 42.666667 0 0 0 54.357334 5.802667l5.973333-4.864 384-371.541334a42.666667 42.666667 0 0 0 5.802667-54.357333l-4.864-5.973333-384-396.458667z" p-id="2256" fill={baseConfig.titleColor || '#111111'}></path>
            </svg>
          </div>
        </div>
        {
          couponsConfig.couponNumber === '单张券'
            ? this.renderSingleCoupon()
            : this.renderMultipleCoupon()
        }
      </Fragment>
    )
  }

  renderOldVersionUI() {
    const { is_rec } = this.state;
    const { baseConfig, imgsList } = this.props.config;
    // 判断不同布局方式下的间距取值
    if (baseConfig.sortType === "一行一图") {
      Object.assign(baseConfig, baseConfig.layout_1);
    } else if (baseConfig.sortType === "一行二图") {
      Object.assign(baseConfig, baseConfig.layout_2);
    } else if (baseConfig.sortType === "一行三图") {
      Object.assign(baseConfig, baseConfig.layout_3);
    } else if (baseConfig.sortType === "banner") {
      Object.assign(baseConfig, baseConfig.layout_banner);
    }

    // 转为数字处理，后续参与计算
    baseConfig.imgMarginHorizon = isNaN(Number(baseConfig.imgMarginHorizon))
      ? 0
      : Number(baseConfig.imgMarginHorizon);
    baseConfig.imgMarginVertical = isNaN(Number(baseConfig.imgMarginVertical))
      ? 0
      : Number(baseConfig.imgMarginVertical);
  
    return (
      <Fragment>
        {
          !is_rec ? (
            <div className="img-list">
              {imgsList.map((item, index) => {
                let rowItemNumber = 3; // 每行排列数量
                if (
                  baseConfig.sortType === "一行一图" ||
                  baseConfig.sortType === "banner"
                ) {
                  rowItemNumber = 1;
                } else if (baseConfig.sortType === "一行二图") {
                  rowItemNumber = 2;
                } else if (baseConfig.sortType === "一行三图") {
                  rowItemNumber = 3;
                }

                const isFirstRow = Boolean(index < rowItemNumber); // 该项是否在首行
                const isLasthRow = Boolean(imgsList.length - index < rowItemNumber); // 该项是否在未行
                const isFirstColumn = Boolean(index % rowItemNumber === 0);
                const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列

                // 计算每个项的宽度
                const totalMargin =
                  (rowItemNumber - 1) * baseConfig.imgMarginHorizon;
                const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
                const itemStyle = {
                  width: itemWidth,
                  marginTop: isFirstRow
                    ? "0"
                    : `${baseConfig.imgMarginVertical / 2}px`,
                  marginBottom: isLasthRow
                    ? "0"
                    : `${baseConfig.imgMarginVertical / 2}px`,
                  marginLeft: isFirstColumn
                    ? "0"
                    : `${baseConfig.imgMarginHorizon / 2}px`,
                  marginRight: isLastColumn
                    ? "0"
                    : `${baseConfig.imgMarginHorizon / 2}px`,
                };

                // 判断图片圆角值
                let imgBorderRadius = "6px";
                if (baseConfig.sortType === "banner" || baseConfig.noImgRadius) {
                  // banner图片或者选择不添加圆角情况，值为0
                  imgBorderRadius = "0";
                }

                return (
                  <div
                    className="img-item"
                    key={index}
                    style={itemStyle}
                    onClick={this.handleItemClick.bind(this, item, index)}
                  >
                    <img
                      className="img"
                      style={{ borderRadius: imgBorderRadius }}
                      src={item.src + "?imageslim|imageMogr2/interlace/1"}
                    />
                  </div>
                )
              })}
            </div>
          ) : this.renderCouponsList()
        }
        { this.renderPopup() }
      </Fragment>
    )
  }

  renderCouponsList = () => {
    const { coupon_list, expire_time } = this.state;
    const { couponsConfig } = this.props.config;
    return (
      <div className="coupons-info" style={{backgroundColor: couponsConfig.couponBackgroundColor}}>
        <p className="title">{couponsConfig.couponTitle}</p>
        <p className="rule" onClick={() => this.handleRuleClick()}>{'使用规则 >'}</p>
        <div className="coupon-list">
          <div className="scroll">
            <ul>
              {
                coupon_list.map((item, index) => {
                  return (
                    <div className="coupon-item" key={index}>
                      <img src={couponsConfig.couponBackgroundImage} alt="" />
                      <div className="content">
                        <p className="money"><span>￥</span>{parseFloat(item.cash_back)}</p>
                        <p className="desc">{parseFloat(item.start_amount) > 0 ? `满${parseFloat(item.start_amount)}返` : '无门槛'}</p>
                      </div>
                    </div>
                  )
                })
              }
            </ul>
          </div>
        </div>
        {
          !couponsConfig.noCountDown && (
            <p className="count-down">
              <CountDown end_time={expire_time} isNewVersionUI={this.isNewVersionUI} />
            </p>
          )
        }
      </div>
    )
  }

  renderPopup = () => {
    const { baseConfig = {} } = this.props.config;
    const { popupShow } = this.state;
    if (popupShow) {
      return (
        <Fragment>
          <div className="mask">
            <div className="popup">
              <h3 className="title">返现券使用说明</h3>
              <div className="rule-txt" dangerouslySetInnerHTML={{ __html: baseConfig.ruleTxt }}></div>
              <img src="https://static.shihuocdn.cn/admin/files/20210513/a46af66b3552cc3cc5cbc82929448a96.png" alt="" className="image" />
              <div className="btn" onClick={() => this.closePopup()}>立即使用</div>
              <img src="https://static.shihuocdn.cn/admin/files/20210513/fa6afe3624dbbdab7e7d5344fdf492a2.png" alt="" className="close" onClick={() => this.closePopup()} />
            </div>
          </div>
        </Fragment>
      ) 
    } else {
      return null;
    }
  }
}

PipelineCashBackAct.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineCashBackAct };
export default PipelineCashBackAct;



// WEBPACK FOOTER //
// ./components/pipeline-cashBackAct/index.js